// Librerias
import React from 'react'
let PropTypes = React.PropTypes
// CSS
import * as css from './TablaArchivos.css'
// Componente
import { RowArchivo } from './RowArchivo.jsx'

export class TablaArchivos extends React.Component{
    render(){
        let totalInventarios = this.props.archivos.length
        return <div className="row">
            <TablaArch>
                {_.range(0, totalInventarios).map(index=>{
                    let archivo = this.props.archivos[index]
                    return <RowArchivo
                        ref={index}
                        key={archivo? archivo.cons_id : index}
                        archivo={archivo}
                        correlativo={index+1}
                    />
                })}
            </TablaArch>
        </div>
    }
}
TablaArchivos.propTypes = {
}
let TablaArch = ({children})=>
    <div className={'panel panel-primary'}>
        <div className={'panel-heading'}>
            {'Archivos consolidados disponibles'}
        </div>
        <table className={'table table-striped table-hover no-margin table-condensed '+css.tablaArchivos}>
            <thead>
            <tr>
                <th className={css.thCorrelativo}>#</th>
                <th className={css.thNombre}>Archivo</th>
                <th className={css.thTipo}>Tipo</th>
                <th className={css.thUsuario}>Subido por</th>
                <th className={css.thFecha}>Fecha subida</th>
                <th className={css.thResultado}>Resultado</th>
                <th className={css.thBoton}>Descargar</th>
            </tr>
            </thead>
            <tbody>
            {children}
            </tbody>
        </table>
    </div>


// WEBPACK FOOTER //
// ./frontEnd/auditorias/consolidados/TablaArchivos.jsx